define('responsive-gameday/views/distributors/viewDistributors/FieldDistributor',['require','exports','module','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','GameDayCore/GDUtil/dataMapping/NumberWithOrdinal','extant/extant','gameday-resource-path/gameday-resource-path','Responsive/util/imageDensity','jquery'],function(require,exports,module) {
    var ViewDistributorClass = require("./ViewDistributorBase"),
        UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../events/DistributionEvents"),
        NumberWithOrdinal = require("GameDayCore/GDUtil/dataMapping/NumberWithOrdinal"),
        exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        imageDensity = require( 'Responsive/util/imageDensity' ),
        $ = require('jquery');

    var Superclass;

    function extractHits (inning){
        return inning.hits;
    }

    function FieldDataPack(game){
        var live = game.liveData,
            innings = live.plays.playsByInning;

        this.hits = innings.map(extractHits);
        this.offense = live.players.offense;
        this.defense = live.players.defense;
        this.venue = $.extend({},game.gameData.venue);
    }

    FieldDataPack.prototype={

        /* Template Helpers */
        anchor: function () {
            return '<a href="#player=' + this.id + '">' + this.name.boxname + '</a>';
        },

        fullname: function () {
            return this.name && (this.name.first + " " + this.name.last) || '';
        },

        playerVsPlayer: function () {
            var batter = this.batter,
                pitcher = this.pitcher;
            return (batter && batter.name.last || "" ) + " vs. " + (pitcher && pitcher.name.last || '');
        },

        playerFieldStats: function () {
            return this.seasonStats.fielding.putOuts + " PO, " + this.seasonStats.fielding.assists + " A, " + this.seasonStats.fielding.errors + " E, " + this.seasonStats.fielding.fielding + " FLDG%";
        },

        playerRunnerStats: function () {
            var batter = this.seasonStats.batting,
                stolenBases = batter.stolenBases ? batter.stolenBases : "0",
                caughtStealing = batter.caughtStealing ? batter.caughtStealing : "0";
            return stolenBases + " SB, " + caughtStealing + " CS";
        },

        inningWithOrdinal: function () {
            return NumberWithOrdinal(this.inning);
        },
         /**
          * @TODO : Talk to Matt about updating these calcs
          */
        top: function () {
            var top = parseFloat(this.coordinates.y);
            if(top < 50) {
                return top;
            } else {
                return top * 1.15;
            }
        },
         /**
          * @TODO : Talk to Matt about updating these calcs
          */
        left: function () {
            var left = parseFloat(this.coordinates.x);
            if(left < 100) {
                return left * 0.75;
            } else {
                return left * 1.15;
            }
        },

        hitOutMarkerClass: function() {
            var coords = this.coordinates;
            return "hitoutdata-" + Math.floor(coords.x) + "" + Math.floor(coords.y) + "" + this.inning;
        }
    };

    function FieldDistributor() {
        Superclass.constructor.call(this);
        this.eventType = UpdateEvents.UPDATE_FIELD_VIEW;
        MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_FIELD_VIEW_DATA, this.handleUpdateRequest);
    }

    ViewDistributorClass.spawn(FieldDistributor).define({
        prepDataForView: function() {

            this.dataPack = new FieldDataPack(this.game);
            // this.dataPack.
            this.dispatchUpdates();
        }
    });

    Superclass = FieldDistributor.superclass;

    return FieldDistributor;
});
